import { isAndroidDevice, isIOSDevice, isMobileBrowser } from "../../Utils/Utilities";
import { Label } from "../UI/label";
import { User, Users, Contact } from "lucide-react";

const NameInput = ({
    fieldID,
    label,
    placeholder,
    value,
    onChange,
    onContactPickerClick,
    required = false,
    className = "space-y-1.5",
    maxLength = 100,
    showContactPicker = false,
    disabled = false
}) => {
    const handleInputChange = (e) => {
        onChange(e);
    };

    return (
        <div key={fieldID} className={className}>
            <Label
                htmlFor={fieldID}
                required={required}
            >
                {label}
            </Label>
            <div className="flex w-full h-11 bg-white sahi-input sahi-radius overflow-hidden">
                <input
                    id={fieldID}
                    name={fieldID}
                    type="text"
                    maxLength={maxLength}
                    value={value}
                    onChange={handleInputChange}
                    placeholder={placeholder}
                    autoComplete="off"
                    tabIndex={0}
                    disabled={disabled}
                    className="flex-1 border-0 focus:ring-0 focus:outline-none bg-transparent px-3 py-2 h-full placeholder:text-muted-foreground text-sm min-w-0 disabled:cursor-not-allowed disabled:opacity-50"
                />
                {(showContactPicker && (isAndroidDevice() || isIOSDevice()) && !isMobileBrowser()) && (
                    <button
                        type="button"
                        onClick={disabled ? undefined : onContactPickerClick}
                        disabled={disabled}
                        className={`h-11 w-10 flex items-center justify-center px-3 bg-background border-l border-gray-300 shrink-0 focus:outline-none transition-colors ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-50'}`}
                        title={disabled ? undefined : "Select from contacts"}
                        tabIndex={-1}
                    >
                        <Contact className="w-5 h-5 text-gray-600" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default NameInput;